import { useTranslation } from "react-i18next";

const LoadingProcessModal = ({ loaderSrc }) => {
    const { t } = useTranslation();

    return (
        <div
            className="modal"
            style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
            id="dateModal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="dateModalLabel"
            aria-hidden="true"
        >
            <div className="modal fade show alertpopup d-block" role="status" aria-live="polite">
                <div className="modal-dialog modal-dialog-centered modal-custom-width">
                    <div className="modal-content modal-radius">
                        <div className="modal-body">
                            <div className="modal-des mt-35 text-center">
                                <p>{t("calender_request_pending_will_processed")}</p>
                                <div className="modal-img text-center">
                                    <img className="warning-icon" src={loaderSrc} alt={t("loading")} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoadingProcessModal;
